import React from "react";

import { Ds } from "@accurx/design";

export const MapWorkspaceCollapsibleInfo = ({
    workspaceName,
    addOrgClick,
}: {
    workspaceName: string;
    addOrgClick?: () => void;
}) => {
    return (
        <Ds.CollapsibleInfo>
            <Ds.CollapsibleInfo.Trigger>
                Help with choosing an organisation
            </Ds.CollapsibleInfo.Trigger>
            <Ds.CollapsibleInfo.Content>
                <Ds.Flex flexDirection="column" gap="2" alignItems="flex-start">
                    <Ds.Text color="inherit">
                        Your organisation is the organisation that{" "}
                        {workspaceName} operates within.
                    </Ds.Text>

                    <ul>
                        <li>
                            If your service is operated by an NHS Trust, select
                            the Trust as your organisation
                        </li>
                        <li>
                            If your service is operated by an independent
                            organisation providing NHS service (such as a
                            pharmacy or other independent healthcare provider),
                            select the site or branch where your service is
                            based
                        </li>
                    </ul>

                    {!!addOrgClick && (
                        <>
                            <Ds.Text color="inherit">
                                If you can't find your organisation below,
                                submit the organisation's details for review.
                            </Ds.Text>
                            <Ds.Button
                                appearance="secondary"
                                onClick={() => addOrgClick()}
                            >
                                Submit an organisation
                            </Ds.Button>
                        </>
                    )}
                </Ds.Flex>
            </Ds.CollapsibleInfo.Content>
        </Ds.CollapsibleInfo>
    );
};
